import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ddf0ed9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "address" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "address-title" }, "收件地址", -1))
const _hoisted_3 = { class: "address-list" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<li class=\"address-list-item add\" data-v-4ddf0ed9><div class=\"add-container\" data-v-4ddf0ed9><div class=\"add-icon\" data-v-4ddf0ed9><i class=\"iconfont icon-plus\" data-v-4ddf0ed9></i></div><p class=\"add-title\" data-v-4ddf0ed9>添加新地址</p></div></li>", 1)
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "btns" }
const _hoisted_7 = {
  key: 0,
  class: "btn-default"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "修改", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "删除", -1))
const _hoisted_10 = {
  key: 0,
  class: "icon"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "默认", -1))
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      _hoisted_4,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addressList, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.id,
          class: "address-list-item"
        }, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(item.name), 1),
          _createElementVNode("p", null, "电话：" + _toDisplayString(item.mobile), 1),
          _createElementVNode("p", null, "地址：" + _toDisplayString(item.address), 1),
          _createElementVNode("p", null, "邮编：" + _toDisplayString(item.postcode), 1),
          _createElementVNode("p", _hoisted_6, [
            (!item.isDefault)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "设为默认地址"))
              : _createCommentVNode("", true),
            _hoisted_8,
            _hoisted_9
          ]),
          (item.isDefault)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}